export class Constant {
  static URL = "https://httpbin.org/absolute-redirect/99999999999";
}
